/* Nzaam Gallery <-> Variant Sync v1
 * Image swipe => variant select, variant select => gallery move.
 * Mapping comes from <script data-nz-map> inside media-gallery (snippets/product-media-gallery.liquid).
 * Variant changes go through the theme's own <variant-selects> => product-info flow
 * (price, SKU, stock, button state, URL all update natively).
 */
(function () {
  if (window.NzGallerySync) {
    window.NzGallerySync.initAll();
    return;
  }

  function mediaIdOf(li) {
    var raw = li && li.dataset.mediaId;
    return raw ? Number(raw.split('-').pop()) : null;
  }

  function Sync(gallery) {
    this.g = gallery;
    this.pi = gallery.closest('product-info');
    this.list = gallery.querySelector('.product__media-list');
    var mapEl = gallery.querySelector('script[data-nz-map]');
    if (!this.pi || !this.list || !mapEl) return;

    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var self = this;
    this.section = this.pi.dataset.section;
    this.variants = {};
    var byMedia = {};
    map.v.forEach(function (v) {
      self.variants[v.id] = v;
      if (v.m) (byMedia[v.m] = byMedia[v.m] || []).push(v.id);
    });

    /* owner: media ID -> variant IDs.
       A variant's featured image starts its group; the images after it belong to
       that variant until the next variant image. Videos/3D never change the variant. */
    this.owner = {};
    var cur = null;
    map.m.forEach(function (m) {
      if (byMedia[m.id]) cur = byMedia[m.id];
      if (byMedia[m.id] || (m.t === 'image' && cur)) self.owner[m.id] = cur;
    });

    this.vid = this.readVariantId();
    this.programmatic = false;
    this.touched = false;
    this.lastIndex = -1;
    this.step = 0;

    this.buildDots();
    this.bind();
    this.alignToActive(false);
    gallery.__nzSync = this;
  }

  Sync.prototype.items = function () {
    return this.list.querySelectorAll('li[data-media-id]');
  };

  Sync.prototype.readVariantId = function () {
    var input = this.pi.querySelector('#product-form-' + this.section + ' input[name="id"]');
    var id = input && Number(input.value);
    return id || (Object.keys(this.variants).length === 1 ? Number(Object.keys(this.variants)[0]) : null);
  };

  Sync.prototype.isSlider = function () {
    return this.list.scrollWidth > this.list.clientWidth + 2;
  };

  Sync.prototype.activeItem = function () {
    return this.list.querySelector('li.is-active[data-media-id]') || this.items()[0];
  };

  Sync.prototype.itemForMedia = function (mediaId) {
    return this.list.querySelector('li[data-media-id$="-' + mediaId + '"]');
  };

  /* ---------- dots (mobile) ---------- */
  Sync.prototype.buildDots = function () {
    var holder = this.g.querySelector('slider-component[id^="GalleryViewer"]') || this.g;
    var old = holder.querySelector(':scope > .nz-dots');
    if (old) old.remove();
    var n = this.items().length;
    this.dots = [];
    if (n < 2) return;
    var wrap = document.createElement('div');
    wrap.className = 'nz-dots';
    wrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < n; i++) {
      var d = document.createElement('span');
      d.className = 'nz-dot';
      wrap.appendChild(d);
      this.dots.push(d);
    }
    holder.appendChild(wrap);
  };

  Sync.prototype.updateDots = function (index) {
    if (index === this.lastIndex || !this.dots.length) return;
    if (this.dots[this.lastIndex]) this.dots[this.lastIndex].classList.remove('is-on');
    if (this.dots[index]) this.dots[index].classList.add('is-on');
    this.lastIndex = index;
  };

  /* ---------- gallery movement ---------- */
  Sync.prototype.setActive = function (li) {
    var prev = this.list.querySelector('li.is-active[data-media-id]');
    if (prev === li) return false;
    if (prev) prev.classList.remove('is-active');
    li.classList.add('is-active');
    var thumbs = this.g.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs) {
      thumbs.querySelectorAll('button[aria-current]').forEach(function (b) { b.removeAttribute('aria-current'); });
      var t = thumbs.querySelector('[data-target="' + li.dataset.mediaId + '"] button');
      if (t) t.setAttribute('aria-current', 'true');
    }
    if (prev && typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    return true;
  };

  Sync.prototype.goTo = function (li, smooth) {
    if (!li) return;
    var items = this.items();
    this.setActive(li);
    this.updateDots(Array.prototype.indexOf.call(items, li));
    if (!this.isSlider()) return;
    var left = li.offsetLeft - items[0].offsetLeft;
    if (Math.abs(this.list.scrollLeft - left) < 2) return;
    this.programmatic = true;
    this.list.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'instant' });
  };

  Sync.prototype.alignToActive = function (smooth) {
    this.goTo(this.activeItem(), smooth);
  };

  Sync.prototype.indexFromScroll = function () {
    var items = this.items();
    if (items.length < 2) return 0;
    if (!this.step) this.step = items[1].offsetLeft - items[0].offsetLeft || this.list.clientWidth;
    var i = Math.round(this.list.scrollLeft / this.step);
    return Math.max(0, Math.min(items.length - 1, i));
  };

  /* ---------- variant handling ---------- */
  Sync.prototype.syncSwatches = function (id) {
    var v = this.variants[id];
    this.pi.querySelectorAll('.nzv__swatch').forEach(function (sw) {
      sw.classList.toggle('is-active', Number(sw.dataset.variantId) === id);
    });
    var label = this.pi.querySelector('#NzSelectedLabel');
    if (label && v) label.textContent = v.t;
  };

  /* Called when the variant is known to have changed (click, swipe, server response). */
  Sync.prototype.onVariant = function (id, moveGallery, smooth) {
    id = Number(id);
    if (!this.variants[id]) return;
    this.vid = id;
    this.syncSwatches(id);
    if (!moveGallery) return;
    var v = this.variants[id];
    if (!v.m) return;
    var active = this.activeItem();
    var owners = this.owner[mediaIdOf(active)];
    if (owners && owners.indexOf(id) > -1) return; /* already showing one of this variant's images */
    this.goTo(this.itemForMedia(v.m), smooth);
  };

  /* Push a variant into the theme's native picker so product-info does the rest. */
  Sync.prototype.commit = function (id) {
    var v = this.variants[id];
    var vs = this.pi.querySelector('variant-selects');
    if (!v || !vs) return;
    var fieldsets = vs.querySelectorAll('fieldset');
    var fire = null;
    v.o.forEach(function (val, i) {
      var fs = fieldsets[i];
      if (!fs) return;
      fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
        var on = r.value === val;
        if (on && !r.checked) fire = r;
        r.checked = on;
        var lbl = r.closest('.nz-sw');
        if (lbl) lbl.classList.toggle('nz-sw--on', on);
      });
      var sel = fs.querySelector('[data-selected-value]');
      if (sel) sel.textContent = val;
    });
    if (!fire) fire = vs.querySelector('fieldset input:checked');
    if (fire) fire.dispatchEvent(new Event('change', { bubbles: true }));
  };

  Sync.prototype.select = function (id, moveGallery) {
    id = Number(id);
    if (!id || id === this.vid) {
      if (moveGallery) this.onVariant(id, true, true);
      return;
    }
    this.onVariant(id, moveGallery, true);
    this.commit(id);
  };

  /* Pick the best variant for an image shared by several variants:
     keep the customer's other options (e.g. size), prefer in-stock. */
  Sync.prototype.pick = function (ids) {
    var cur = this.variants[this.vid];
    var best = null, score = -1, self = this;
    ids.forEach(function (id) {
      var v = self.variants[id], s = 0;
      if (cur) v.o.forEach(function (o, i) { if (o === cur.o[i]) s += 2; });
      if (v.a) s += 1;
      if (s > score) { score = s; best = id; }
    });
    return best;
  };

  Sync.prototype.variantForMedia = function (mediaId) {
    var owners = this.owner[mediaId];
    if (!owners || owners.indexOf(this.vid) > -1) return null;
    return this.pick(owners);
  };

  Sync.prototype.onSettle = function () {
    if (!this.isSlider()) return;
    var items = this.items();
    var index = this.indexFromScroll();
    var li = items[index];
    if (!li) return;
    this.updateDots(index);
    this.setActive(li);
    if (this.programmatic) { this.programmatic = false; return; }
    var target = this.variantForMedia(mediaIdOf(li));
    if (target) this.select(target, false);
  };

  /* ---------- events ---------- */
  Sync.prototype.bind = function () {
    var self = this, raf = 0, timer = 0;

    this.list.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; self.updateDots(self.indexFromScroll()); });
      clearTimeout(timer);
      timer = setTimeout(function () { self.onSettle(); }, 150);
    }, { passive: true });

    if ('onscrollend' in window) {
      this.list.addEventListener('scrollend', function () { clearTimeout(timer); self.onSettle(); });
    }

    this.list.addEventListener('touchstart', function () { self.touched = true; self.programmatic = false; }, { passive: true });

    window.addEventListener('resize', function () { self.step = 0; }, { passive: true });

    /* Visible swatches (.nzv) */
    this.pi.addEventListener('click', function (e) {
      var sw = e.target.closest('.nzv__swatch');
      if (sw && self.pi.contains(sw)) self.select(sw.dataset.variantId, true);
    });
    this.pi.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var sw = e.target.closest('.nzv__swatch');
      if (!sw) return;
      e.preventDefault();
      self.select(sw.dataset.variantId, true);
    });

    /* Desktop thumbnails (if shown): image click also selects its variant */
    var thumbs = this.g.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var item = e.target.closest('[data-target]');
        if (!item) return;
        var target = self.variantForMedia(Number(item.dataset.target.split('-').pop()));
        if (target) self.select(target, false);
      });
    }

    /* Server-confirmed variant (theme's own flow) => keep swatches in sync */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var data = evt && evt.data;
        if (!data || !data.variant || !self.g.isConnected) return;
        if (data.sectionId !== (self.pi.dataset.originalSection || self.section)) return;
        self.onVariant(data.variant.id, false);
      });
    }

    /* Late layout (async slider CSS / images) on first load */
    window.addEventListener('load', function () {
      self.step = 0;
      if (!self.touched) self.alignToActive(false);
    }, { once: true });

    /* Back/forward cache restore */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var id = self.readVariantId();
      if (id) self.onVariant(id, true, false);
    });
  };

  window.NzGallerySync = {
    initAll: function () {
      document.querySelectorAll('media-gallery[data-nz-sync]').forEach(function (g) {
        if (!g.__nzSync) new Sync(g);
      });
    },
  };

  window.NzGallerySync.initAll();
  document.addEventListener('product-info:loaded', function () { window.NzGallerySync.initAll(); });
})();
